<template>
  <el-dialog
    :title="$t('reportCustomGroupManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div style="text-align: center;">
      <p>{{ $t('reportCustomGroupManage.confirmDeleteReportGroup') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('reportCustomGroupManage.cancelOperation') }}</el-button>
      <el-button type="primary" @click="deleteReportCustomGroup" :loading="loading">
        {{ $t('reportCustomGroupManage.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteReportCustomGroup as apiDelete } from '@/api/dev/reportCustomGroupApi'

export default {
  name: 'DeleteReportCustomGroup',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      deleteReportCustomGroupInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteReportCustomGroupInfo = { ...row }
    },
    handleClose() {
      this.loading = false
      this.deleteReportCustomGroupInfo = {}
    },
    async deleteReportCustomGroup() {
      this.loading = true
      try {
        await apiDelete(this.deleteReportCustomGroupInfo)
        this.$message.success(this.$t('reportCustomGroupManage.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除报表组失败:', error)
        this.$message.error(error.message || this.$t('reportCustomGroupManage.deleteFailed'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>